import { render } from "./BaseTwoThirdsColumn.vue?vue&type=template&id=23d2a2a2"
import script from "./BaseTwoThirdsColumn.vue?vue&type=script&lang=js"
export * from "./BaseTwoThirdsColumn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__